const DATA = [
    {
        id : 0,
        title :" iPhone 12",
        price :800,
        desc :"Display size 6.10, Screen resolution 1170x2532, Image Brightness 625 cd/m²,Contrast 2,000,000:1, Pixel density 460 ppi,OLED display technology,Touch screen Capacitive, Haptic response when pressed",
        img :"/assets/images/products/12pro.png",
        category: "IPhone"

    },
    {
        id : 1,
        title :" iPhone 12 Pro",
        price :900,
        desc :"Display size 6.10, Screen resolution 1170x2532, Image brightness 800 cd/m², Contrast 2,000,000:1, Pixel density 460 ppi, OLED display technology",
        img : "/assets/images/products/iphone12.png",
        category: "IPhone"

    },
    {
        id : 2,
        title :"iPhone 13",
        price :1000,
        desc :"Display size 6.10, Screen resolution 1170x2532, Image brightness 800 cd/m², Contrast 2,000,000:1, Pixel density 460 ppi, OLED display technology",
        img :"/assets/images/products/iphone13.png",
        category: "IPhone"

    },

    {
        id : 3,
        title :"iPhone 13 pro",
        price : 1200,
        desc :"Display size 6.10, Screen resolution 1170x2532, Image brightness 800 cd/m², Contrast 2,000,000:1, Pixel density 460 ppi, OLED display technology",
        img :"/assets/images/products/iphone13pro.png",
        category: "IPhone"

    },

    {
        id : 5,
        title : "iPhone 14",
        price : 1300,
        desc :"Display size 6.10, Screen resolution 1170x2532, Image brightness 800 cd/m², Contrast 2,000,000:1, Pixel density 460 ppi, OLED display technology",
        img : "/assets/images/products/12pro.png",
        category: "IPhone"

    },

    {
        id : 6,
        title :"iPhone 14 pro",
        price :1450,
        desc : "Display size 6.10, Screen resolution 1170x2532, Image brightness 800 cd/m², Contrast 2,000,000:1, Pixel density 460 ppi, OLED display technology",
        img : "/assets/images/products/iphone14plus.png",
        category: "IPhone"

    },

    {
        id : 7,
        title :"IPad Pro 11",
        price :1450,
        desc : "Apple M2 chip delivers incredible performance boosts for demanding tasks and allows you to work on a single charge all day",
        img : "/assets/images/products/ipadpro11.png",
        category: "IPad"

    },
    {
        id : 8,
        title :"IPad Air",
        price :1300,
        desc : "Apple M1 chip takes iPad Air performance to the next level, delivering all-day battery life. The 10.9-inch Liquid Retina display provides an immersive experience.",
        img : "/assets/images/products/ipadair.png",
        category: "IPad"

    },
    {
        id : 9,
        title :"IPad Mini",
        price :800,
        desc : "Get amazing performance and all-day battery life with the A15 Bionic processor.Stunning 8.3 Liquid Retina display with True Tone technology and P3 wide color gamut",
        img : "/assets/images/products/ipadmini.png",
        category: "IPad"

    },
    {
        id : 10,
        title :"IPad (10th generation)",
        price :900,
        desc : "The A14 Bionic chip allows you to work in multiple applications at the same time and smoothly switch between them.",
        img : "/assets/images/products/ipad10.png",
        category: "IPad"

    },

    {
        id : 11,
        title :"MacBook Air M1",
        price :1500,
        desc : "Apple M1 chip for outstanding CPU, GPU and machine learning performance. Battery lasts up to 18 hours, more than ever before.Vibrant colors and stunning detail on the Retina display. Ultra-fast SSD for lightning-fast access to apps and files",
        img : "/assets/images/products/mba1.png",
        category: "Mac"

    },
    {
        id : 12,
        title :"MacBook Air M2",
        price :1200,
        desc : "Apple M2 chip for outstanding CPU, GPU and machine learning performance. Battery lasts up to 18 hours, more than ever before.Vibrant colors and stunning detail on the Retina display. Ultra-fast SSD for lightning-fast access to apps and files",
        img : "/assets/images/products/mba2.png",
        category: "Mac"

    },
    {
        id : 13,
        title :"MacBook pro",
        price :1800,
        desc : "Apple M2 chip for outstanding CPU, GPU and machine learning performance. Battery lasts up to 18 hours, more than ever before.Vibrant colors and stunning detail on the Retina display. Ultra-fast SSD for lightning-fast access to apps and files",
        img : "/assets/images/products/mbapro.png",
        category: "Mac"

    },

    {
        id : 14,
        title :"iMac",
        price :2000,
        desc : "Apple M1 chip for outstanding CPU, GPU and machine learning performance. Battery lasts up to 18 hours, more than ever before.Vibrant colors and stunning detail on the Retina display. Ultra-fast SSD for lightning-fast access to apps and files",
        img : "/assets/images/products/imac.png",
        category: "Mac"

    },

]

export default DATA
